import React from 'react';
import NumberFormatField from 'shared/components/numberFormatField/NumberFormatField';

class RepSection extends React.Component {
  render() {
    return (
      <div className="rep-section">
        <div className="section-title">
          Custom Rep
          <i className="fas fa-chevron-down"></i>
        </div>
        <NumberFormatField
          name="reps"
          label="Custom Rep"
          placeholder="Input Number"
          allowNegative={false}
          isAllowed={true}
        />
      </div>
    );
  }
}

export default RepSection;
